/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
// import DomEventsManager from 'scripts/dom-events-manager';
import Chartist from 'vendors/chartist/chartist';

export var Recap = BaseControl.extend({
    init: function() {
        this._super();
        // DomEventsManager.subscribe(this);
        var chartData = [
            0,
            4,
            1,
            1,
            2,
            2,
            3,
            3,
            -3,
            -4,
            -4,
            -3,
            -6,
            4,
            6,
            3,
            4,
            2,
            3,
        ];

        this.chartData = $.map(chartData, function(e) {
            return (e / 6) * 4.9; // we take 5 as 100% instead of 6
        });

        this.chartContainer = this.$element.find('.recap-chart-wrapper');
        this.chartHeight = this.chartContainer.find('.chart-area').height();

        this.positiveArea = this.chartContainer.find(
            '.positive-chart .chart-area',
        );
        this.negativeArea = this.chartContainer.find(
            '.negative-chart .chart-area',
        );

        this.drawChart(this.positiveArea, this.chartHeight, this.chartData);
        this.drawChart(this.negativeArea, this.chartHeight, this.chartData);
    },

    onLayout: function() {
        this.renderCharts();
    },

    renderCharts: function() {
        this.drawChart(this.positiveArea, this.chartHeight, this.chartData);
        this.drawChart(this.negativeArea, this.chartHeight, this.chartData);
    },

    drawChart: function(chartContainer, chartHeight, data) {
        chartContainer.empty();

        new Chartist.Line(
            chartContainer,
            {
                series: [
                    {
                        name: 'chart-area',
                        data: data,
                    },
                ],
            },
            {
                chartPadding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                },
                fullWidth: true,
                showArea: true,
                showPoint: false,
                height: chartHeight + 'px',
                showLine: false,
                high: 5,
                low: -5,
                axisY: {
                    showLabel: false,
                    offset: 0,
                    showGrid: false,
                },
                axisX: {
                    showGrid: false,
                    showLabel: false,
                    offset: 0,
                },
                lineSmooth: Chartist.Interpolation.cardinal({
                    fillHoles: true,
                    tension: 0.3,
                }),
            },
        );
    },
});
